import { Page } from '~/models/PaginatedItems'
import { WallPinRepository } from './repository'
import { TextWallPinData, WallPin } from '~/models/WallPin'

export class WallPinService {
	static async getWallPins(
		tripId: string,
		page?: number,
		pageSize?: number
	): Promise<Page<WallPin>> {
		return await WallPinRepository.getWallPins(tripId, page, pageSize)
	}

	static async createWallPin(tripId: string, wallPin: WallPin): Promise<WallPin> {
		return await WallPinRepository.createWallPin(tripId, wallPin)
	}

	static async updateTextData(
		tripId: string,
		wallPinId: string,
		textData: TextWallPinData
	): Promise<WallPin> {
		return await WallPinRepository.updateWallPinData(tripId, wallPinId, textData)
	}

	static async deleteWallPin(tripId: string, wallPinId: string): Promise<void> {
		return await WallPinRepository.deleteWallPin(tripId, wallPinId)
	}

	static clearPins(tripId: string): void {
		WallPinRepository.clearWallPins(tripId)
	}
}
